//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import FiniquitoList from '@/views/HumanResource/HrFiniquito/list/FiniquitoList'
import CreateMain from '@/views/HumanResource/HrFiniquito/create/main/CreateMain'
import ShowEdit from '@/views/HumanResource/HrFiniquito/showEdit/FiniquitoShowEdit'

//
export default {
    path: 'finiquitos',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'finiquito-list',
            component: FiniquitoList,
        },
        {
            path: 'create',
            name: 'finiquito-create',
            component: CreateMain,
        },
        {
            path: ':id',
            name: 'finiquito-update',
            component: ShowEdit,
        },
    ],
    meta: {
        title: 'Finiquitos',
    },
}
